/* eslint-disable max-len */
import type { FC } from 'react';

import type { BreakPatternProps } from './breakPatternTypes';

export const HeadBreak: FC<BreakPatternProps> = props => {
  const { topColor, bottomColor, shadowColor, shadowOpacity = 0.2, ...rest } = props;
  return (
    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      role="presentation"
      {...rest}
    >
      <defs>
        <filter id="break-head-shadow" x="0" y="0" width="100%" height="96">
          <feGaussianBlur stdDeviation="15" />
          <feComposite operator="out" in2="SourceGraphic" />
        </filter>
      </defs>

      {/* Top section */}
      <path
        d="M1440 0H0L-0.00390625 65C228.186 32.4746 470.064 21 720.555 21C971.045 21 1212.14 32.5811 1439.99 65L1440 0Z"
        fill={topColor}
      />

      {/* Bottom section */}
      <path
        d="M1439.99 43.9999L1440 75C896.804 75.3096 544.733 75 -0.00292327 75L-0.00463491 44C228.185 11.4751 470.065 8.66536e-05 720.555 6.42749e-05C971.044 4.18962e-05 1212.14 11.5812 1439.99 43.9999Z"
        fill={bottomColor}
        transform="translate(0 21)" // Move to bottom of the SVG container
      />

      {/* Drop shadow (same path as the top section with the filter applied) */}
      <path
        d="M1440 0H0L-0.00390625 65C228.186 32.4746 470.064 21 720.555 21C971.045 21 1212.14 32.5811 1439.99 65L1440 0Z"
        fill={shadowColor}
        opacity={shadowOpacity}
        filter="url(#break-head-shadow)"
      />
    </svg>
  );
};
